import React from 'react';
import { Stack } from '@mui/material';
import Header from '../components/Header';
import AdminContainer from '../components/AdminContainer';
const AdminPage = () => {

    return (
        <Stack alignItems="center" sx={{flex: 1, height: '100%'}}>
            <Header/>
            <AdminContainer/>
        </Stack>
    );
};

export default AdminPage;
